import React from 'react';
import { Grid, Card, CardContent, Stack, Box, Typography, Avatar } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { LoadingWrapper } from '../loading';

const MoneyAccountStatsCards = ({ stats, isLoading }) => {
  const statsCards = [
    {
      title: 'Total Accounts',
      value: stats.total_accounts || 0,
      icon: <AccountBalanceWalletIcon />,
      color: 'primary.main',
    },
    {
      title: 'Total Balance',
      value: Number(stats.total_balance || 0).toLocaleString(undefined, { maximumFractionDigits: 2 }),
      icon: <AccountBalanceIcon />,
      color: 'success.main',
    },
    {
      title: 'Active Accounts',
      value: stats.active_accounts || 0,
      icon: <TrendingUpIcon />,
      color: 'info.main',
    },
  ];

  return (
    <LoadingWrapper
      isLoading={isLoading}
      skeletonCount={3}
      showSectionTitle
      sectionTitle="Overview"
      containerSx={{ width: '100%' }}
    >
      <Grid container spacing={2}>
        {statsCards.map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card>
              <CardContent>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      {stat.title}
                    </Typography>
                    <Typography variant="h4">{stat.value}</Typography>
                  </Box>
                  <Avatar sx={{ bgcolor: stat.color, color: 'primary.contrastText' }}>{stat.icon}</Avatar>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </LoadingWrapper>
  );
};

export default MoneyAccountStatsCards;